import styled from "styled-components";
import { Accordion } from "react-bootstrap";
import Form from "react-bootstrap/esm/Form";
import InputGroup from "react-bootstrap/esm/InputGroup";

export const Container = styled.div`
  font-family: "Poppins", sans-serif;
  display: block;
  max-height: 100px;
`;

export const TitleChevronContainer = styled.span`
  display: flex;
  align-items: center;
  max-width: 90vw;

  & > span:nth-child(2) {
    margin-right: 15px;
  }
`;

export const Chevron = styled.span<{ toggleClosed: boolean }>`
  margin-top: ${props => (props.toggleClosed ? "-5px" : "5px")};
  margin-left: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  transform: ${props => (props.toggleClosed ? "rotate(45deg)" : "rotate(-135deg)")};
`;

export const AccordionToggle = styled(Accordion.Toggle)<{ width: number }>`
  background-color: var(--secondary);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 4px;
  padding: 5px 15px;
  color: white;
  width: ${props => `${props.width - 15}px`};
`;

export const StyledFormControl = styled(Form.Control)`
  max-width: 245px;
  height: 29px;
  font-size: 12px;
`;

export const StyledInputGroupText = styled(InputGroup.Text)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem 0 0 0.25rem;
  border-right: 0;
  width: 29px;
  height: 29px;
  background-color: #afafaf;

  svg,
  path {
    fill: #fff;
  }
`;
